import { IAccountOption } from '../../../../providers/venue-provider';
import './styles.scss';

import TransactionsBody from './transactions-body';

interface TransactionsProps {
  accountOption: IAccountOption;
}

const Transactions = ({ accountOption }: TransactionsProps) => {
  return (
    <div className="transactions-container">
      <TransactionsBody accountOption={accountOption} />
    </div>
  );
};

export default Transactions;
